import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-white text-gray-600 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12 text-center md:text-left">
          <div className="flex flex-col items-center md:items-start">
            <a href="/" className="">
                <img src="/site-logo.png" alt="Company Logo" className="h-10 w-auto" />
            </a>
            <div className="mt-6 flex gap-4 items-center">
              <img src="/assets/edwosb-certification.png" alt="EDWOSB Certified" className="h-16 w-auto" />
              <img src="/assets/swam-certification.png" alt="SWAM Certified" className="h-16 w-auto" />
            </div>
          </div>

          {/* Federal Contractor Information */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="text-slate-700 text-lg font-semibold mb-4">Federal Contractor ID</h3>
            <div className="space-y-2 text-sm">
              <p><span className="text-gray-500">UEI:</span> Y52BX7LQGEV5</p>
              <p><span className="text-gray-500">CAGE:</span> 9XKP0</p>
              <p><span className="text-gray-500">DUNS:</span> 13-239-8048</p>
            </div>
          </div>

          {/* Contact Information */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="text-slate-700 text-lg font-semibold mb-4">Contact Us</h3>
            <div className="space-y-3 text-sm">
              <Link to="/schedule" className="inline-flex items-center whitespace-nowrap bg-accent text-white font-semibold px-6 h-10 rounded-md hover:bg-accent-500 transition-colors duration-200">
                Schedule a Consultation
              </Link>
              <div className="flex items-center gap-3">
                <a href="mailto:info@onyxroseadvisors.com" className="hover:text-accent transition-colors underline">
                  info@onyxroseadvisors.com
                </a>
                <span className="text-gray-400">|</span>
                <a href="https://www.linkedin.com/company/onyx-rose-advisors/about/?viewAsMember=true" target="_blank" rel="noopener noreferrer" className="text-onyx-700 hover:text-accent transition-colors duration-200" >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                  </svg>
                </a>
              </div>
              <div className="mt-4 space-y-3">
                <div>
                  <p className="font-semibold text-slate-700">Virginia</p>
                  <p className="leading-relaxed">
                    8000 Towers Crescent Drive<br />
                    13<sup>th</sup> Floor<br />
                    Vienna, VA 22182
                  </p>
                </div>
                <div>
                  <p className="font-semibold text-slate-700">Washington, DC</p>
                  <p className="leading-relaxed">
                    99 M Street SE<br />
                    8<sup>th</sup> Floor<br />
                    Washington, DC 20003
                  </p>
                </div>
              </div>
              <p>
                <a href="tel:+15715826010" className="hover:text-accent transition-colors">
                  (571) 582-6010
                </a>
              </p>
            </div>
          </div>
          <div className="flex flex-col items-center md:items-start">
            <Link to="/news" className="inline-flex items-center whitespace-nowrap bg-accent text-white font-semibold px-6 h-10 rounded-md hover:bg-accent-500 transition-colors duration-200 mt-4">
              News and Updates
            </Link>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-8 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} Onyx Rose Advisors. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
